// Frontend mirror of backend PERMISSIONS. Keep in sync with /app/backend/server.py.
// Backend is the source of truth; this is only for hiding UI a role can't use.
const PERMS = {
  "users:manage":       ["owner"],
  "settings:manage":    ["owner"],
  "audit:read":         ["owner"],

  "cylinders:read":     ["owner", "manager", "accountant", "delivery_entry", "staff"],
  "cylinders:write":    ["owner", "manager", "staff"],
  "cylinders:adjust":   ["owner", "manager"],
  "cylinders:delete":   ["owner"],

  "boys:read":          ["owner", "manager", "accountant", "delivery_entry", "staff"],
  "boys:write":         ["owner", "manager", "accountant", "staff"],
  "boys:delete":        ["owner"],

  "customers:read":     ["owner", "manager", "accountant", "delivery_entry", "staff"],
  "customers:write":    ["owner", "manager", "accountant", "delivery_entry", "staff"],
  "customers:delete":   ["owner"],

  "collections:read":   ["owner", "manager", "accountant", "staff"],
  "collections:write":  ["owner", "manager", "accountant", "staff"],
  "collections:delete": ["owner"],

  "expenses:read":      ["owner", "manager", "accountant", "delivery_entry", "staff"],
  "expenses:write":     ["owner", "manager", "accountant", "delivery_entry", "staff"],
  "expenses:delete":    ["owner"],

  "bank:read":          ["owner", "manager", "accountant", "staff"],
  "bank:write":         ["owner", "manager", "accountant", "staff"],
  "bank:delete":        ["owner"],

  "reports:read":       ["owner", "manager", "accountant", "staff"],
  "closing:read":       ["owner", "manager", "accountant", "staff"],
};

export function can(user, action) {
  if (!user) return false;
  if (user.role === "owner") return true;
  const allowed = PERMS[action];
  return Array.isArray(allowed) && allowed.includes(user.role);
}

export const ROLE_LABEL = {
  owner: "Owner",
  manager: "Manager",
  accountant: "Accountant",
  delivery_entry: "Delivery Entry",
  staff: "Staff",
};
